import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@7f-ui/components/accordion/accordion';
import type { AccommodationImportantNotesEnum } from '@data-access/graphql/schema.types';
import type { Icon } from '@phosphor-icons/react';
import { ArrowUpRight, Baby, Car, Dog, FaceMask, HandHeart, Path, ShieldCheck, Suitcase, Wheelchair } from '@phosphor-icons/react';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { sanitizeBackendHtml } from '@/lib/security/sanitize-html';
const ACCOMMODATION_IMPORTANT_NOTES_LABELS: Record<string, string> = {
  Accessible: 'Barrierefrei',
  AgeRestrictions: 'Alterbeschränkungen',
  ArrivalInstructions: 'Anfahrt',
  CheckInCheckOut: 'Check-in und Check-out',
  Hygiene: 'Abstand- und Hygieneregeln',
  Parking: 'Parken',
  Pets: 'Haustiere',
  Security: 'Sicherheit',
  Services: 'Dienstleistungen',
  Transfer: 'Transfer'
};
type AccommodationImportantNotesProps = {
  accommodation: AccommodationFragment;
};
export function AccommodationImportantNotes(t0) {
  const $ = _c(4);
  const {
    accommodation
  } = t0;
  let t1;
  if ($[0] !== accommodation.importantNotes) {
    t1 = accommodation.importantNotes.map(_temp);
    $[0] = accommodation.importantNotes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="grid gap-5 sm:gap-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(t0) {
  const {
    key,
    html
  } = t0;
  return <Accordion Icon={ICONS[key]} title={ACCOMMODATION_IMPORTANT_NOTES_LABELS[key] ?? key} key={key}><div className="html-text group-open:pt-4" dangerouslySetInnerHTML={{
      __html: sanitizeBackendHtml(html)
    }} /></Accordion>;
}
const ICONS: Record<AccommodationImportantNotesEnum, Icon> = {
  ArrivalInstructions: Path,
  Transfer: ArrowUpRight,
  Parking: Car,
  CheckInCheckOut: Suitcase,
  Accessible: Wheelchair,
  Pets: Dog,
  Services: HandHeart,
  AgeRestrictions: Baby,
  Security: ShieldCheck,
  Hygiene: FaceMask
};